const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default function isValidEmail(value: string | null | undefined): boolean {
  return EMAIL.test((value ?? '').trim())
}
